/* eslint-disable no-useless-escape */
import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { textFormat } from "utils/Utils";
import FindStructureData from "helper/FindStructureType";
import { Grid, withStyles } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "../../components/UpdateUi/CustomeSelect";
import ToastModal from "views/components/ToastModal";
import { sortByString } from "utils/Utils";
import { userDataConfig } from "assets/properties/properties";
import { commonButton } from "assets/properties/properties";
import { toastAction } from "assets/properties/properties";
import CustomTextSelect from "components/UpdateUi/CustomeTextSelect";
import { parseAndSetFlag } from "utils/Utils";
import { removeAllSpaces } from "utils/Utils";
import { sanitizeUsernameOrEmail } from "utils/Utils";
import { particularDesignationAccess } from "assets/properties/properties";
const UserInvite = ({ classes }) => {
  const params = useParams();
  let navigate = useNavigate();
    const {
      createSuccess,
      button,
      emailError,
      mainUrl,
      updateUser,
      viewLabel,
    } = userDataConfig;

  const [userId, setUserId] = useState("");
  const [name, setName] = useState("");
  const [nameState, setNameState] = useState(false);
  const [username, setUserName] = useState("");
  const [usernameState, setUserNameState] = useState(false);
  const [email, setEmail] = useState("");
  const [emailState, setEmailState] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileNumberState, setMobileNumberState] = useState(false);
  const [branchId, setBranchId] = useState("");
  const [branchCode, setBranchCode] = useState("");
  const [branchCodeList, setBranchCodeList] = useState([]);
  const [branchCodeState, setBranchCodeState] = useState(false);
  const [selectedRoleCode, setSelectedRoleCode] = useState("");
  const [selectedRoleCodeState, setSelectedRoleCodeState] = useState(false);
  const [designation, setDesignation] = useState("");
  const [designationState, setDesignationState] = useState(false);
  const [structureTypeList, setStructureTypeList] = useState([]);
  const [selectedMasterType, setSelectedMasterType] = useState("");
  const [selectedMasterTypeState, setSelectedMasterTypeState] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [isActive, setIsActive] = useState("");
  const [roleList, setRoleList] = useState([]);
  const [employeeId, setEmployeeId] = useState("");
  const [employeeState, setEmployeeState] = useState(false)
  const dispatch = useDispatch();
  const viewPage = window.location.href.includes('createview');
  const [redirectURL, setRedirectURL] = useState("");
  const [emailCheckFlags, setEmailCheckFlags] = useState(false);
  const [designationData, setDesignationData]= useState([])
  const [selectedBranchCode,setSelectedBranchCode]=useState([]);
  const [expendedBranches, setExpandedBranches] = useState(false);
  const [expandedBranchCodeList, setExpandedBranchCodeList]= useState([]);
  const [defaultBranches, setDefaultBranches]= useState([]);
  const [password, setPassword]=useState("");
  const [passwordErrorState, setPasswordErrorState]=useState(false)
  const outletData = useOutletContext();
  const emailDomainNameFlags = outletData?.emailDomainNameFlag;
  const skipEmailInviteUserFlag = parseAndSetFlag(outletData?.skipEmailInviteUser) || false;
  const multiBranchUserEnable = parseAndSetFlag(outletData?.enableMultiBranchUsers);
  const enableMultiBranchAsPerUser = outletData?.enabledMultiBranchAsPerUser || [];
  const multiBranchUserEnabled = multiBranchUserEnable || enableMultiBranchAsPerUser?.includes(designation)
  const { userDetails } = useSelector((state) => state.userDetail.userDetails);
  // display find user
  useEffect(() => {
      getRoleList();
    // getBranchList();
    (async () => {
      if (params.id) {
        setCallInProgress(true);
        //ADMIN_USER_FINDID
        const result = await apiHandler({
          url: endpoint.ADMIN_USER_FINDID + params.id,
          authToken: authToken,
        });
        setCallInProgress(false);
        setEmployeeId(result?.data?.employeeId)
        setDesignation(result?.data?.designation);
        setUserId(result?.data?.id);
        setSelectedMasterType(textFormat(result?.data?.masterTypeCode));
        setBranchCode(textFormat(result?.data?.branchCode));
        setName(result?.data?.name);
        setUserName(result?.data?.username);
        setEmail(result?.data?.email);
        setMobileNumber(result?.data?.mobileNumber);
        setBranchId(result?.data?.branchId);
        setSelectedRoleCode(textFormat(result?.data?.role));
        setDefaultBranches(result?.data?.defaultBranches);
        setIsActive(result?.data?.active);
        if (result?.data?.masterTypeCode) {
          getBranchList(result?.data?.masterTypeCode);
        }
        if (result?.data?.branchCodes?.length > 0) {
          setExpandedBranches(true);
          setSelectedBranchCode(result.data.branchCodes);
        } else {
          setExpandedBranches(false);
          setSelectedBranchCode([]);
        }
      }
    })();
  }, []);

  useEffect(() => {
      FindStructureData(
        apiHandler,
        endpoint,
        authToken,
        setStructureTypeList
      );
      getDesignationFindAll();
  }, []);

  useEffect(()=>{
    if(params?.id && branchCode && multiBranchUserEnabled){
         getAllBranchDetails();
      }
  },[branchCode])

  const getRoleList = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_ROLE_FIND,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate(toastAction?.error, result?.data?.user_description, true);
    } else {
      const expectUserData = result?.data?.filter((item) => item.name !== "User");
      expectUserData.push({
        role: "role_branch_checker",
        name: "Branch Checker",
      });
      setRoleList(expectUserData);
    }
  };
  const getAllBranchDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FIND_ALL_BRANCH,
         authToken: authToken,
    });
    setCallInProgress(false);
    if(!result?.data?.error_code){
        const defaultBranchCodes = defaultBranches?.map(item => item.toLowerCase()) || [];

      const updatedBranches = result?.data?.filter(
        branch => !defaultBranchCodes.includes(branch.code.toLowerCase())
      );
      const structuredData = [
      {
        code: 1,
        name: "All Branches",
        children: updatedBranches || [],
      },
    ];

    setExpandedBranchCodeList(structuredData);
    }
  }
  console.log(expandedBranchCodeList,expandedBranchCodeList.length,"ajfsjkfdbskdjfb")
  const getDesignationFindAll = async ()=>{
    setCallInProgress(true)
      const result = await apiHandler({
        url: endpoint.DESIGNATION_FINDALL,
        authToken: authToken,
      });
      setCallInProgress(false)
      if(result?.data){
      const filteredData = result?.data?.filter((item) => !particularDesignationAccess.includes(item?.designation));
      const desingationWise = particularDesignationAccess.includes(userDetails?.designation) ? result?.data :  filteredData;
        const sortedArray = sortByString(desingationWise, 'designation', true);
        setDesignationData(sortedArray);
      }
  }
  const getBranchList = async (code) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_HIERARCHY_FIND_BY_TYPE_CODE + code.toUpperCase(),
      authToken: authToken,
    });
    setCallInProgress(false);

    if (result?.data?.error_code) {
      toastUpdate(toastAction?.error, result?.data?.user_description, true);
    } else {
      const sortedArray = sortByString(result?.data, 'name', true);
      setBranchCodeList(sortedArray);
    }
  };
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const onChangeCheckbox = (e, type) => {
    const value = e.target.checked;
    setIsActive(value);
  };
  // validation for Edit Function
  const isEditValidated = () => {
    if(name===''){setNameState(true)}else{setNameState(false)}
    if(mobileNumber ==='' || mobileNumber.length!==10){setMobileNumberState(true)}else{setMobileNumberState(false)}
    if(email==='' && !skipEmailInviteUserFlag){setEmailState(true)}else{setEmailState(false)}
    if(employeeId === "" || typeof employeeId === "undefined"){setEmployeeState(true)}else{setEmployeeState(false)}
    // if(designation ==="" || typeof designation === "undefined"){setDesignationState(true)}else{setDesignationState(false)}
    if(name && mobileNumber && mobileNumber.length === 10 && ((email && !skipEmailInviteUserFlag) || skipEmailInviteUserFlag) && employeeId){return true}else{ return false}
  };
  // validation function
  const isValidated = () => {
    if (selectedMasterType === "") {
      setSelectedMasterTypeState(true);
    } else {
      setSelectedMasterTypeState(false);
    }
    if (branchCode === "") {
      setBranchCodeState(true);
    } else {
      setBranchCodeState(false);
    }
    if (selectedRoleCode === "") {
      setSelectedRoleCodeState(true);
    } else {
      setSelectedRoleCodeState(false);
    }
    if (name === "") {
      setNameState(true);
    } else {
      setNameState(false);
    }
    if (username === "") {
      setUserNameState(true);
    } else {
      setUserNameState(false);
    }
    if (mobileNumber === "" && mobileNumber.length!==10) {
      setMobileNumberState(true);
    } else {
      setMobileNumberState(false);
    }
    if (email === "" && !skipEmailInviteUserFlag) {
      setEmailState(true);
    } else {
      setEmailState(false);
    }
    if(employeeId === ""){
      setEmployeeState(true)
    }else{
      setEmployeeState(false)
    }
    if(skipEmailInviteUserFlag && password === ""){
      setPasswordErrorState(true)
    }else{
      setPasswordErrorState(false)
    }
    if (
      selectedMasterType &&
      branchCode &&
      selectedRoleCode &&
      name &&
      username &&
      mobileNumber &&
      mobileNumber.length === 10 &&
       employeeId && ((skipEmailInviteUserFlag && password) || (!skipEmailInviteUserFlag && email))
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getApiRole = (role) => {
    return role?.toLowerCase() === "role_branch_checker"
      ? "role_checker"
      : role?.toLowerCase();
  };
  const createUserSubmit = async () => {
    if (isValidated()) {
     toastUpdate("", "", false)
     setCallInProgress(true);
      //ADMIN_USER_ADD
      const res = await apiHandler({
        url: endpoint.ADMIN_USER_INVITE,
        method: "POST",
        authToken: authToken,
        data: {
          name: name,
          email: email?.toLowerCase(),
          mobileNumber: mobileNumber,
          role: getApiRole(selectedRoleCode),
          username: skipEmailInviteUserFlag ? sanitizeUsernameOrEmail(username) : username?.toLowerCase(),
          hierarchyCode: branchCode !== "none" ? branchCode?.toUpperCase() : "",
          employeeId: employeeId,
          designation:designation,
          skipEmail:skipEmailInviteUserFlag,
          password:password,
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate(toastAction?.error, res?.data?.user_description, true);
        return;
      } else {
        toastUpdate(toastAction?.success, createSuccess, true);
        setRedirectURL(mainUrl);
      }
    }
  };
  const editUserSubmit = async () => {
    if (isEditValidated()) {
      toastUpdate("", "", false);
      // ADMIN_USER_UPDATE
      setCallInProgress(true);
      let branch =
        branchCodeList && branchCodeList.filter((b) => b.code === branchCode);
      const res = await apiHandler({
        url: endpoint.ADMIN_USER_UPDATE,
        method: "POST",
        authToken: authToken,
        data: {
          id: userId,
          name: name,
          email: email?.toLowerCase(),
          mobileNumber: mobileNumber,
          role: getApiRole(selectedRoleCode),
          username: skipEmailInviteUserFlag ? sanitizeUsernameOrEmail(username) : username?.toLowerCase(),
          hierarchyCode: branchCode !== "none" ? branchCode?.toUpperCase() : "",
          active: isActive,
          employeeId: employeeId,
          designation:designation,
          branchCodes:selectedBranchCode
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate(toastAction?.error, res?.data?.user_description, true);
        return;
      } else {
        toastUpdate(toastAction?.success, updateUser, true);
        setRedirectURL(mainUrl);
      }
    }
  };

  const handlecreateuserSubmit = async (event) => {
    if (params.id) {
      editUserSubmit();
    } else {
      createUserSubmit();
    }
  };
  // cancel button function
  const handlecanceluser = () => {
    navigate(mainUrl);
  };

  const masterTypeChange = (event) => {
    setSelectedMasterType(event);
    getBranchList(event);
  };
  const changeEmailData = (event) => {
    setEmail(event);
    if(!skipEmailInviteUserFlag){
    setUserName(event);
    }
  };
  const handleBlur = (event) => {
    const enteredEmail = event; // Assuming the event is a change event on an input field

    // Check if emailDomainNameFlags is defined, not null, and not empty
    if (!emailDomainNameFlags || emailDomainNameFlags === undefined || emailDomainNameFlags === null) {
        setEmail(enteredEmail);
         if(!skipEmailInviteUserFlag){
            setUserName(enteredEmail);
         }
        return;
    }

    const emailDomainNameFlag = emailDomainNameFlags.split(',');
    const enteredDomain = enteredEmail.split('@')[1];
    const containsAllowedDomain = emailDomainNameFlag.includes(enteredDomain);

    setEmail(containsAllowedDomain ? enteredEmail : '');
    if(!skipEmailInviteUserFlag){
    setUserName(containsAllowedDomain ? enteredEmail : '');
    }
    if (!containsAllowedDomain) {
      toastUpdate(toastAction?.error, `${emailError} ${emailDomainNameFlag.join(', ')}`, true);
    }
};
  
  const onBlurError = (e, type) => {
    if (e && e.length < 10 || e && e.length > 10 ){
      setMobileNumberState(true);
    } else {
      setMobileNumberState(false);
    }
  };
  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setMobileNumber(e);
    }
  };

  const handleSelect = (selectedItems) => {
    console.log("Selected:", selectedItems);
    setSelectedBranchCode(selectedItems);
  };
  const title = viewPage? viewLabel : button;
  const branch =  branchCodeList && branchCodeList.filter((b) => b.status !== "INACTIVE");
  return (
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SubHeader
            label={title}
            button1={!viewPage && commonButton?.button1}
            button2={commonButton?.button2}
            button1click={!viewPage && handlecreateuserSubmit}
            button2click={handlecanceluser}
          />
        </Grid>

      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Master Type*"
              id="master_type"
              error={selectedMasterTypeState}
              value={selectedMasterType}
              setState={masterTypeChange}
              data={structureTypeList}
              setError={setSelectedMasterTypeState}
              disabled={viewPage}
            />
          </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Home Branch*"
              id="home_branch"
              error={branchCodeState}
              value={branchCode}
              setState={setBranchCode}
              data={branch}
              setError={setBranchCodeState}
              disabled={!selectedMasterType || viewPage}
            />
          </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Role*"
              error={selectedRoleCodeState}
              id="user_role"
              value={selectedRoleCode}
              setState={setSelectedRoleCode}
              data={roleList}
              setError={setSelectedRoleCodeState}
              type="role"
              disabled={viewPage}
            />
          </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Name"
              required
              error={nameState}
              id="lp_userinvite_name"
              value={name || ""}
              setState={setName}
              setError={setNameState}
              disabled={viewPage}
            />
          </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Username"
              required
              error={usernameState}
              type="notCapital"
              id="lp_userinvite_username"
              value={skipEmailInviteUserFlag ? sanitizeUsernameOrEmail(username) : username?.toLowerCase() || ""}
              setState={setUserName}
              setError={setUserNameState}
              disabled={!skipEmailInviteUserFlag || (skipEmailInviteUserFlag && (viewPage || params.id))}
            />
          </Grid>
           {skipEmailInviteUserFlag && !params?.id && <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Password"
              required
              error={passwordErrorState}
              type="notCapital"
              id="lp_userinvite_username"
              value={password|| ""}
              setState={setPassword}
              setError={setPasswordErrorState}
            />
          </Grid>}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Designation*"
              error={designationState}
              id="designationS"
              value={designation}
              setState={setDesignation}
              data={designationData}
              setError={setDesignationState}
              type="designation"
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Mobile Number"
              required
              error={mobileNumberState}
              id="lp_branch_phone_number"
              value={mobileNumber || ""}
              setState={handleChange}
              maxLength="10"
              setBlur={onBlurError}
              blurLabel="mobileNumber"
              disabled={viewPage}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Email Address"
              error={emailState}
              type="notCapital"
              required
              id="lp_emailAddress"
              value={email?.toLowerCase() || ""}
              setState={changeEmailData}
              setError={setEmailState}
              disabled={viewPage || (params?.id && !skipEmailInviteUserFlag)}
              setBlur={handleBlur}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Employee ID"
              error={employeeState}
              type="notCapital"
              required
              id="employeeId"
              value={employeeId || ""}
              setState={setEmployeeId}
              setError={setEmployeeState}
              disabled={viewPage}
            />
          </Grid>
          {(params?.id && multiBranchUserEnabled && expandedBranchCodeList?.[0]?.children?.length > 0 )&& <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
             <CustomTextSelect data={expandedBranchCodeList} onSelect={handleSelect} selectedBranchCodes={selectedBranchCode} initiallyExpanded={expendedBranches}/>
          </Grid>}     
          {params.id && (
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <p style={{ fontWeight: "bold" }}>
                {" "}
                <input
                  id="selectAll"
                  type="checkbox"
                  checked={isActive}
                  className={classes.checkboxInput}
                  onChange={(e) => onChangeCheckbox(e, "USER")}
                  disabled={viewPage}
                />{" "}
                Active
              </p>
            </Grid>
          )}
        </Grid>
      </Grid>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      </Grid>
  );
};

UserInvite.propTypes = {
  classes: PropTypes.object,
};

export default UserInvite;
